import CheckoutForm from './CheckoutForm'
import DeliveryForm from './DeliveryForm'

export default function CheckoutFragment() {
  return (
    <section className="section">
      <div className="container py-3">
        <p className="h3 mb-0">Checkout</p>
        <p className="text-muted">Please review your checkout before proceeding with payment</p>
        <div className="row">
          <div className="col-lg-7 col-12">
            <DeliveryForm />
          </div>

          <div className="col-lg-5 col-xl-4 col-12">
            <CheckoutForm />
          </div>
        </div>
      </div>
    </section>
  )
}
